import ProfileComponent from '@components/profile';
import * as React from 'react';

export interface IProfileProps {}

export default function Profile(props: IProfileProps) {
  return <ProfileComponent />;
}
